export default __webpack_public_path__ + "static/media/10dc.ea6802c1.svg";